import React from 'react';
import {Routes, route} from 'react-router-dom'

const Urls = () => {
    return (
        <Routes>
            
        </Routes>
    );
};

export default Urls;